<template>
  <div class="chat-container">
    <div class="messages" id="chat-container-messages">
      <div v-for="message in messages" :key="message.id" class="message" style="display: flex;align-items: center;">
          <div v-if="message.sender === 'user'" class="message-content" style="background-color: lightblue;float: right;margin-right: 10px;">{{ message.content }}</div>
          <div v-else class="message-content" style="background-color: palevioletred;margin-right: 10px;">
              <div v-if="!message.completed" style="display: flex;align-items: center;">
                  <div v-loading="loading">稍等，请耐心等待...</div>
              </div>
              <div  v-else style="margin-left: 10px;">{{ message.content }}</div>
          </div>
      </div>
    </div>
    <form @submit.prevent="sendMessage" style="margin-top: 10px">
      <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="newMessage" placeholder="Enter message" />
      <button type="submit" style="margin-left: 5px">发送</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loading: false,
      messages: [{id: 0, content: "您好，有什么可以帮到您!", sender: "chat-bot", completed: true}],
      newMessage: ''
    };
  },
  methods: {
    sendMessage() {
        if (this.newMessage === '') return;
        let msg = { id: Date.now().toString(), sender: 'user', content: this.newMessage, completed: true };
        let msg2 = { id: Date.now().toString(), sender: 'chat-bot', content: "正在为您解答，请耐心等待...", completed: false };
        this.messages.push(msg);
        this.messages.push(msg2);
        setTimeout(()=>{
            let div = document.getElementById('chat-container-messages')
            div.scrollTop = div.scrollHeight;
            this.loading = true;
            this.$post("/ver_ai/intelligent_agent_chat", msg).then((resp) => {
                this.loading = false;
                if (resp.code !== 'E000000') return;
                this.messages[this.messages.length-1] = { id: Date.now().toString(), sender: 'chat-bot', content: resp.data.output_text, completed: true };
                setTimeout(()=>{
                    let div = document.getElementById('chat-container-messages')
                    div.scrollTop = div.scrollHeight;
                }, 100)
            });
            this.newMessage = '';
        }, 100)
        // this.$post("/ver_ai/intelligent_agent_chat", msg).then((resp) => {
        //     if (resp.code !== 'E000000') return;
        //     let new_rsp = { id: Date.now().toString(), sender: 'chat-bot', content: resp.data.output_text }
        //     this.messages.push(new_rsp);
        //     setTimeout(()=>{
        //         let div = document.getElementById('chat-container-messages')
        //         div.scrollTop = div.scrollHeight;
        //     }, 100)
        // });
        // this.newMessage = '';
    }
  }
};
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.messages {
  overflow-y: scroll;
  flex: 1;
}
.message {
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
.message-content {
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-bottom: 5px;
}
form {
  display: flex;
}
input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 5px;
}
button {
  padding: 10px 15px;
  background-color: #6fa3ef;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
